import React, { useState, useEffect, useRef } from "react";
import FolderIcon from "./img/folder.webp";
import MediaIcon from "./img/mediaIcon.png";
import sharepointIcon from "./img/spIcon.svg";
import { Button, Form, Spinner } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { useConfig } from "./ConfigContext";

export default function DateiUbersicht({ estateId, ownerData, sharepointIDs, sharepointObject, spLink }) {
   const config = useConfig();
   const [showUbersicht, setShowUbersicht] = useState(false);

   return (
      <>
         <div className="file-buttongroup">
            <button
               className="custom-button my-1"
               style={showUbersicht ? { boxShadow: "0 0 4px 6px #CFE2FF" } : {}}
               title="Dateien anzeigen/verbergen"
               onClick={(e) => {
                  console.log(ownerData);

                  e.preventDefault();
                  setShowUbersicht(true);
               }}
            >
               <img src={FolderIcon} /> {sharepointIDs && <span>{Object.values(sharepointIDs).flat().length}</span>}{" "}
               Dateien
            </button>
         </div>
         <div className="file-buttongroup">
            {config.company === "baur" && (
               <a
                  target="_blank"
                  className=" custom-button my-1 "
                  style={{ opacity: 0.3 }}
                  title="Bilder und Videos"
                  rel="noopener noreferrer"
                  href={null}
               >
                  <img src={MediaIcon} /> Medien
               </a>
            )}

            {config?.ms365?.active && (
               <a
                  target="_blank"
                  className=" custom-button my-1 ms-1"
                  title="Link zum Sharepoint (Datei-Ordner)"
                  rel="noopener noreferrer"
                  href={spLink}
               >
                  <img src={sharepointIcon} /> Sharepoint ↗
               </a>
            )}
         </div>

         <Modal show={showUbersicht} size="xl" onHide={() => setShowUbersicht(false)}>
            <Modal.Body>
               <div className="nachrichten-ubersicht">
                  {Object.keys(sharepointIDs).length > 0 && (
                     <>
                        <h3>
                           <img className="me-3" src={FolderIcon} height={36} />
                           Dateien
                        </h3>
                        {Object.keys(sharepointIDs).map((kachel) => (
                           <div key={"spDateiuberkey_" + kachel} className="kachel-notizbereich">
                              <h5>{kachel}</h5>
                              <div
                                 style={{
                                    margin: "4px 0px",
                                    display: "flex",
                                    flexDirection: "row",
                                    gap: "5px",
                                    flexWrap: "wrap",
                                 }}
                              >
                                 {sharepointIDs[kachel] &&
                                    sharepointIDs[kachel].map((spDatei, index2) => {
                                       let urlData;

                                       if (sharepointObject && sharepointObject[spDatei.name]) {
                                          const cleanFileData = sharepointObject && sharepointObject[spDatei.name];

                                          urlData = encodeURIComponent(
                                             JSON.stringify({
                                                id: cleanFileData.id,
                                                driveId: cleanFileData.parentReference.driveId,
                                                parentId: cleanFileData.parentReference.id,
                                                name: cleanFileData.name,
                                                kachel: kachel
                                                // file: cleanFileData.file,
                                             }),
                                          );
                                       }

                                       return (
                                          <div
                                             className="kachel-notiz"
                                             style={{
                                                display: "flex",
                                                position: "relative",
                                                flexDirection: "column",
                                                width: "calc(100% / 4 - 4px)",
                                                borderRadius: 10,
                                                // ...(spDatei.public2 ? { boxShadow: "0 0 10px #0009" } : {}),
                                             }}
                                             key={"spDatkey_" + index2}
                                          >
                                             {sharepointObject && sharepointObject[spDatei.name] ? (
                                                <>
                                                   <div
                                                      style={{
                                                         borderRadius: 20,
                                                         position: "absolute",
                                                         top: 5,
                                                         right: 5,
                                                         width: 20,
                                                         aspectRatio: 1,
                                                         ...(spDatei.public2
                                                            ? { background: "#0c0", boxShadow: "0 0 20px #fff" }
                                                            : {}),
                                                      }}
                                                   ></div>
                                                   <strong style={spDatei.public2 ? {} : { color: "#000" }}>
                                                      {sharepointObject[spDatei.name].name}
                                                   </strong>

                                                   <div
                                                      style={{
                                                         display: "flex",
                                                         flexDirection: "row",
                                                         justifyContent: "center",
                                                      }}
                                                   >
                                                      {/* <img
                                                      src={sharepointObject[spDatei.name].thumbnails[0].small.url}
                                                      width={96}
                                                      height={96}
                                                   /> */}
                                                      <div
                                                         style={{
                                                            display: "flex",
                                                            flexDirection: "row",
                                                            margin: 4,
                                                            justifyContent: "center",
                                                         }}
                                                      >
                                                         <a
                                                            title="Zur Datei im Sharepoint"
                                                            target="_blank"
                                                            className="btn btn-outline-primary me-1"
                                                            href={sharepointObject[spDatei.name].webUrl}
                                                         >
                                                            SP ↗
                                                         </a>
                                                         {sharepointObject[spDatei.name].file &&
                                                            sharepointObject[spDatei.name].file.mimeType ===
                                                               "application/pdf" && (
                                                               <a
                                                                  className="btn btn-outline-dark"
                                                                  title="Zum Schwärzen"
                                                                  target="_blank"
                                                                  href={`/redact?estateid=${estateId}&ownerid=${ownerData.ownerid}&sharepointfile=${urlData}`} /* &filename=${sharepointObject[spDatei.name].name}&fileid=${sharepointObject[spDatei.name].id}&driveid=${sharepointObject[spDatei.name].parentReference.driveId}`} */
                                                               >
                                                                  █████ ↗
                                                               </a>
                                                            )}
                                                      </div>
                                                   </div>
                                                </>
                                             ) : (
                                                <span title="Fehlerhafter Link! Möglicherweise wurde die verlinkte Datei aus dem Sharepoint ersetzt oder entfernt.">
                                                   {" "}
                                                   Fehler: {spDatei.name}{" "}
                                                </span>
                                             )}
                                             <footer>
                                                von {spDatei.user} {new Date(spDatei.timestamp).toLocaleString()}
                                             </footer>
                                          </div>
                                       );
                                    })}
                              </div>
                           </div>
                        ))}
                     </>
                  )}
               </div>
            </Modal.Body>
            <Modal.Footer>
               <Button variant="secondary" onClick={() => setShowUbersicht(false)}>
                  Schließen
               </Button>
            </Modal.Footer>
         </Modal>
      </>
   );
}
